import type {RouteParams} from 'types/routes'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {ProcedureNew} from 'pages/withAuth/adminPage/procedureNew/ProcedureNew'

export const ProcedureNewRoutes: RouteParams[] = [
  {
    key: 'procedure_new',
    path: WITH_AUTH_ADMIN_PATHS.PROCEDURE_NEW.INDEX,
    component: ProcedureNew,
    exact: true,
  },
]
